var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable, computed, action } from 'mobx';
import { api } from 'helpers/Api';
import { Tax, TaxCategory } from './Model';
export default class default_1 {
    constructor() {
        this.taxes = [];
        this.loaded = false;
        this.set = (taxes) => {
            this.taxes = taxes.map(tax => new Tax(tax));
            this.loaded = true;
            return this.taxes;
        };
        this.push = (tax) => {
            this.taxes.push(new Tax(tax));
        };
        this.replace = (tax) => {
            this.taxes.splice(this.taxes.findIndex(f => f.id === tax.id), 1, tax);
        };
    }
    get articleTaxes() {
        return this.taxes.filter(tax => tax.category === TaxCategory.Article);
    }
    get customerTaxes() {
        return this.taxes.filter(tax => tax.category === TaxCategory.Customer);
    }
    read(id) {
        if (id)
            return api.get('taxes/' + id);
        return api.get('taxes').then(this.set);
    }
    create(tax) {
        return api.post('taxes', tax).then(this.push);
    }
    update(id, tax) {
        return api.put('taxes/' + id, tax)
            .then((result) => {
            console.log('then - result', result);
            this.replace(result);
        });
    }
}
__decorate([
    observable
], default_1.prototype, "taxes", void 0);
__decorate([
    observable
], default_1.prototype, "loaded", void 0);
__decorate([
    computed
], default_1.prototype, "articleTaxes", null);
__decorate([
    action
], default_1.prototype, "set", void 0);
__decorate([
    action
], default_1.prototype, "push", void 0);
__decorate([
    action
], default_1.prototype, "replace", void 0);



//////////////////
// WEBPACK FOOTER
// ./src/modules/Taxes/Store.ts
// module id = 334
// module chunks = 0